module.exports = __webpack_public_path__ + "images/b368004bfdca25b45ae8bab7f8ca2acb.png";